import axios from "axios";
import urls from "./urls";
export const getStoreMetaData = async () => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_store_meta_data,
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getCSRFCookie = async () => {
    try {
        await axios({
            method: "GET",
            url: urls.get_csrf,
        });
    } catch (error) {
        return error;
    }
}
export const getLoggedUser = async () => {
    try {
        const response = await axios({
            method: 'GET',
            url: urls.get_user
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const userLogin = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: urls.login_url,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const userRegister = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: urls.register_user,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getProductFullDetails = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_product_full_details,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const addItemToCart = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: urls.add_item_to_cart,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getUserCart = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_user_cart,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getCartCount = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_cart_count,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getAppCurrencies = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_app_currencies,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}



export const removeItemFromCart = async (params) => {
    try {
        const response = await axios({
            method: "DELETE",
            url: urls.remove_item_from_cart,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getShippingCost = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_shipping_cost,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const checkoutCart = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: urls.checkout_cart,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getStoreFilters = async () => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_store_filters,
        });
        return response;
    } catch (error) {
        return error;
    }
}


export const getStoreProducts = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_store_products,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getProductActiveVariations = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_product_active_variations,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}

export const getStoreCollections = async () => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_store_collections,
        });
        return response;
    } catch (error) {
        return error;
    }
}


export const getPaymentStatus = async (params) => {
    try {
        const response = await axios({
            method: "GET",
            url: urls.get_payment_status,
            params: params
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getRetryPaymentLink = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: urls.get_retry_payment_link,
            data: data
        });
        return response;
    } catch (error) {
        return error;
    }
}



